import { Component, TemplateRef,  Input, EventEmitter, Output, OnInit, OnChanges } from '@angular/core';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList } from '@angular/cdk/drag-drop';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { InformableSection, InformableSectionItem } from 'globals/store/informables.data';
import { ConfirmDeleteData } from 'src/app/components/dialog.confirmDelete.component';
import { CollapseExpand } from '../../helpers/helpers';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Asset } from 'globals/store/assets.data';
import { Dictionary } from '@ngrx/entity';
import { Ranking } from 'globals/store/events.data';
import { CoreEntityType } from 'globals/store/share.data';
import { IconComponent } from '../icon/icon.component';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { FileLinkComponent } from '../file-handler/file-link.component';
import { AssetLinkComponent } from 'src/app/modules/assets/asset-link.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { EntityTypeDropdownComponent } from '../entities/entity-type-dropdown.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'information',
    templateUrl: './information.html',
    styleUrls: ['information.scss'],
    animations: [
        // trigger('drop', [
        //     state('expand', style({ height: '*', padding: '20px 20px' })),
        //     state('collapse, undefined, void', style({ height: '0', padding: '0 20px' })),
        //     transition('collapse <=> expand', animate('300ms ease-out')),
        //     transition('void => *', animate('0ms')),
        //     transition('undefined => *', animate('0ms'))
        // ])

  trigger('drop', [
    state('expand', style({ height: '*', padding: '20px 20px' })),
    state('collapse', style({ height: '0', padding: '0 20px' })),
    
    // Smooth transition between main states
    transition('collapse <=> expand', animate('300ms ease-out')),
    
    // Instant appearance for entering elements (replaces void/undefined)
    transition(':enter', animate('0ms')),
  ])
    ],
    standalone: true,
    imports: [IconComponent, MatButtonModule, EntityTypeDropdownComponent, IdsToItemsPipe, FileLinkComponent, AssetLinkComponent, MatMenuModule, CdkDragHandle, CdkDropList, CdkDrag, CommonModule ],
})
export class InformationComponent extends Wrapper<InformationComponent> implements OnInit, OnChanges {
  @Input() heading = ''
  @Input() readOnly = true
  @Input() canDeleteFirst = true
  @Input() singleSectionOnly:boolean;
  @Input() noItemsMessage;
  @Input() noPadding = false
  @Input() mobileCollapse = false
  @Input() allCollapse = false
  @Input() deleteSectionTitle = 'Delete this section'
  @Input() deleteSectionParagraph = 'Deleting this section will remove all associated items. This action cannot be undone.'
  @Input() information: InformableSection[] = [] // need to type this, damnit
  @Input() sectionTitleTemplate: TemplateRef<any>;
  @Input() namePlaceholderOverride = ''
  @Input() descriptionPlaceholderOverride = ''

  @Input() entityType: CoreEntityType
  @Input() entityTypesMap: Dictionary<Ranking> = {}

  @Output() deleteInfo: EventEmitter<InformableSection> = new EventEmitter()
  @Output() addItem: EventEmitter<InformableSection> = new EventEmitter()
  @Output() saveInfo: EventEmitter<InformableSection> = new EventEmitter()
  @Output() openItem: EventEmitter<{item: InformableSectionItem, info: InformableSection }> = new EventEmitter()
  @Output() duplicateSection: EventEmitter<InformableSection> = new EventEmitter()

  @Output() dropSection: EventEmitter<CdkDragDrop<InformableSection[]>> = new EventEmitter()
  @Output() dropItem: EventEmitter<CdkDragDrop<string[]>> = new EventEmitter()
  @Output() addSection: EventEmitter<null> = new EventEmitter()

  itemExpandedStates: CollapseExpand = {}
  infoExpandedStates: CollapseExpand = {}
  connectedList = []
  assets: Dictionary<Asset>

  ngOnInit() { 
    this.populateExpanded(this.information)
    this.subProp(this.store.select('assets', 'entities'), 'assets')
  }

  collapseAll() {
    this.information.forEach(({ id }) => this.infoExpandedStates[id] = 'collapse')
    this.information.forEach(({ items }) => items.forEach(({ id }) => this.itemExpandedStates[id] = 'collapse'))
  }

  expandAll() {
    this.information.forEach(({ id }) => this.infoExpandedStates[id] = 'expand')
    this.information.forEach(({ items }) => items.forEach(({ id }) => this.itemExpandedStates[id] = 'expand'))
  }

  populateExpanded(information: InformableSection[]) {
    const collapsed = this.allCollapse || (this.mobileCollapse && window.innerWidth <= 768)
    if (!information) return
    information.filter(({ items }) => items && items.length).forEach(info => info.items
      .filter(({ id }) => !this.itemExpandedStates[id])
      .forEach(({ id }) => this.itemExpandedStates[id] = collapsed ? 'collapse' : 'expand')
    )
  }

  ngOnChanges(changes) {
    if (changes && changes.information && changes.information.currentValue) {
      this.connectedList = changes.information.currentValue.map((_,idx) => 'section_'+idx)
      this.populateExpanded(changes.information.currentValue)
    }
  }

  emitOpenItem(event, item: InformableSectionItem, info: InformableSection ) {
    if(this.readOnly || /ICON/.test(event.target.tagName)) return;
    event.stopPropagation()
    this.openItem.emit({ item: item, info: info })
  }

  toggleInfoBox(evt, id){
    if(evt.target.classList.contains('more')) return;
    this.infoExpandedStates[id] = this.infoExpandedStates[id] === 'collapse' ? 'expand' : 'collapse'
  }

  async updateEntityIds(info: InformableSection, ids: string[]) {
    info.entityTypeIds = ids
    this.saveInfo.emit(info)
  }

  toggleInfo(evt, id) {
    this.itemExpandedStates[id] = this.itemExpandedStates[id] === 'collapse' ? 'expand' : 'collapse';
  }

  
  async deleteSection(evt, info, fromEl) {
    const el = document.getElementsByClassName(fromEl);
    const rect = el[0].getBoundingClientRect();

    const data: ConfirmDeleteData = { rect, title: this.deleteSectionTitle, para: this.deleteSectionParagraph, dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    
    this.deleteInfo.emit(info)
}

  trackBySection(index, section: InformableSection) {
    return section.id
  }

  trackById(index, item) {
    return item.id // index; // or
  }

}
